export default {
  ARTWORK: 'ARTWORK',
  COVER: 'COVER',
  COVER_MINI: 'COVER_MINI',
  HORIZONTAL_POSTER: 'HORIZONTAL_POSTER',
  LOGO: 'LOGO',
  POSTER: 'POSTER',
  POSTER_ARTWORK: 'POSTER_ARTWORK',
  LANDSCAPE: 'LANDSCAPE',
  SQUARE: 'SQUARE',
  SQUARE_MINI: 'SQUARE_MINI',
};
